import $ from 'jquery';

$(() => {
  $('.addresses .address-field:only-child input').attr('checked', 'checked');
  $('.addresses input').on('change', function () {
    $('.addresses input').not(this).prop('checked', false);
  });

  const marketingRadioButtons = $('#subscribe, #unsubscribe');
  const subscribeRadioButton = $('#subscribe');
  const unsubscribeRadioButton = $('#unsubscribe');

  marketingRadioButtons.on('change', function () {
    marketingRadioButtons.not(this).closest('.panel-section').next()
    .find('[type="checkbox"]')
    .prop('checked', false);
  });
  // reset subscribe checkboxes when unsubscribe is selected

  subscribeRadioButton.closest('.panel-section').next().find('[type="checkbox"]')
  .on('change', function () {
    subscribeRadioButton.prop('checked', true);
    if ((!$(this).is(':checked')) && (!$(this).parent().siblings('.panel-section').find('[type="checkbox"]')
    .is(':checked'))) {
      unsubscribeRadioButton.prop('checked', true);
    }
    // check unsubscribe after last unsubscribe checkbox is unchecked
  });
  // check subscribe radio button when any of subscribe checkboxes is checked
});



/** WEBPACK FOOTER **
 ** ./src/js/account.js
 **/